import { scrollToBookingElement } from './booking-scroll-container';
import { getServiceCategoryHeaderOffset } from './service-category-header-offset';

export function scrollToVisibleBookingSection(
  sections: (HTMLElement | null)[],
) {
  const section = sections.find((element) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  });
  if (!section) return;

  const headers = Array.from(
    document.querySelectorAll<HTMLElement>(
      'header, [role="banner"], .site-header',
    ),
  ).flatMap((header) => {
    const style = getComputedStyle(header);
    const rect = header.getBoundingClientRect();
    return (style.position === 'fixed' || style.position === 'sticky') &&
      style.visibility !== 'hidden' &&
      rect.height > 0 &&
      rect.bottom > 0
      ? [rect]
      : [];
  });

  scrollToBookingElement(section, getServiceCategoryHeaderOffset(headers) + 16);
}
